<template>
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <div class="contentBox" v-show="showIndex == 1">
      <div class="item_body">
        <div class="item_tital">
    {{item.tital}}
        </div>

        <div class="item_date">
{{item.date}}
        </div>
        <el-divider></el-divider>
        <div class="item_count">
{{item.count}}
        </div>
        <div class="item_image">
          <div class="item_image_1">
            <img
              class="item_image_1_1"
              :src="item.img.img1">
          </div>
          <div class="item_image_1">
            <img
              class="item_image_1_1"
              :src="item.img.img2">
          </div>
        </div>

      </div>
    </div>
    <div class="contentBox" v-show="showIndex == 2" v-html="itemWord.htmlContent">

    </div>
  </div>
</template>

<script>
import {Data} from "./js/newsItem";

export default {
  name: "newsItem",
  data() {
    return {
      urlData:"",
      dataAll: Data,
      itemData: {},
      item:{},
      itemWord:{},
      showIndex:1

    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.index;
  },
  mounted() {
    let  that = this;
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        that.item = itemData.item;
        break;
      }
    }
    that.init();
  },
  methods: {
    init(){
      let  that = this;

      if(that.urlData != "" && that.urlData !=undefined){
        // console.log(11)
        for ( let itemNE in that.itemData.newList){
          let itemData = that.itemData.newList[itemNE]
          console.log(111)
          console.log(itemData)
          // console.log(itemNE.index)
          if(that.urlData == itemData.index){
            that.item = itemData.item;
            console.log(that.item.type == "html")
            if(that.item.type == 'html'){
              that.itemWord = itemData.item;
              that.item = that.itemData.item;
              that.showIndex = 2;
            }
              console.log(that.item );
            break;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.item_image_1_1{
  width: 100%;
}
.item_image_1{
  margin: 10px;
  width: 50%;
  aspect-ratio: 578/340;
}
.item_image{
  display: flex;
  margin-top: 30px;
  width: 100%;
}
.item_count{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 32px;
  margin-top: 20px;
  white-space: pre-wrap;
}
.item_date{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  text-align: justify;
  margin-top: 20px;
  margin-bottom: 20px;
}
.item_tital{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  margin-top: 20px;
}
.contentBox {
  width: 61.25%;
  margin: 50px auto;
}
.productPage {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/newsItem.vue